module.exports = __webpack_public_path__ + "static/media/23.c03d391e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/23.jpg
// module id = 284
// module chunks = 0